
const modulesApi = {

    async getModulesFromCatalog(catalog){
        const modules = await fetch(window.location.origin + '/api/v1/configurator/quote_item_modules/lookup/' + catalog)
            .then(results => {
                return results.json();
            })
        return modules;
    },

    async getModulesFromQuoteId(quoteItemId){
        const modules = await fetch(window.location.origin + '/api/v1/configurator/quote_item_modules/lookup/quote_item/' + quoteItemId)
        .then(results => {
            return results.json();
        })
        return modules;
    }

};

export default modulesApi;